__turbopack_context__.v({
  "activeMobile": "GKkgWW_activeMobile",
  "backdrop": "GKkgWW_backdrop",
  "currency": "GKkgWW_currency",
  "flags-menu": "GKkgWW_flags-menu",
  "inactiveMobile": "GKkgWW_inactiveMobile",
  "ldropdown-mob": "GKkgWW_ldropdown-mob",
  "megamenu-cms-mobile": "GKkgWW_megamenu-cms-mobile",
  "megamenu-container-bottom": "GKkgWW_megamenu-container-bottom",
  "megamenu-main-menu-wrap": "GKkgWW_megamenu-main-menu-wrap",
  "megamenu-tab-menu-wrap": "GKkgWW_megamenu-tab-menu-wrap",
  "menu-app-burger": "GKkgWW_menu-app-burger",
  "menu-app-burger-open": "GKkgWW_menu-app-burger-open",
  "menu-app-header": "GKkgWW_menu-app-header",
  "menu-app-header-end": "GKkgWW_menu-app-header-end",
  "menu-app-header-start": "GKkgWW_menu-app-header-start",
  "menu-app-logo": "GKkgWW_menu-app-logo",
  "menu-close": "GKkgWW_menu-close",
  "menu-item": "GKkgWW_menu-item",
  "menu-sheet-body": "GKkgWW_menu-sheet-body",
  "menu-sheet-header": "GKkgWW_menu-sheet-header",
  "menu-sheet-title": "GKkgWW_menu-sheet-title",
  "menuCmsIsRoot": "GKkgWW_menuCmsIsRoot",
  "mobile-categories": "GKkgWW_mobile-categories",
  "mobile-subcategories": "GKkgWW_mobile-subcategories",
  "no-submenu": "GKkgWW_no-submenu",
  "pushmenu-links": "GKkgWW_pushmenu-links",
  "submenu-mobile-back": "GKkgWW_submenu-mobile-back",
  "submenu-mobile-upper": "GKkgWW_submenu-mobile-upper",
  "submenu-mobile-upper-tabbar": "GKkgWW_submenu-mobile-upper-tabbar",
  "submenu-mobile-ver-todo": "GKkgWW_submenu-mobile-ver-todo",
  "tab-bar-products-container": "GKkgWW_tab-bar-products-container",
  "u-case": "GKkgWW_u-case",
});
